import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { AlarmState } from './types';
import { RootState } from '../types';

export const state: AlarmState = {
  alarms: [],
  noMoreAlarm: false,
};

const namespaced: boolean = true;

export const alarm: Module<AlarmState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
